export default __webpack_public_path__ + "static/media/swisscom-icon.899b9ca5.png";